<div class="container-loader" *ngIf="isBusy">
    <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
    <!-- <mat-spinner class="loader" strokeWidth="4" [color]="warn" [diameter]="50"></mat-spinner> -->
</div>